import { footer } from "./components/footer";
import { navbar } from "./components/navbar";
import "./index.css";
import { aboutSection } from "./components/aboutPage/aboutSection";

document.querySelector("#root")!.innerHTML = navbar + aboutSection + footer;

const Scrollnavbar = document.getElementById("navbar");

window.addEventListener("scroll", () => {
  if (window.scrollY > 10) {
    //@ts-ignore
    Scrollnavbar.classList.add("shadow-md", "bg-white");
  } else {
    //@ts-ignore
    Scrollnavbar.classList.remove("shadow-md", "bg-white");
  }
});
// console.log("Scrollnavbar", Scrollnavbar);
window.addEventListener("load", () => (window as any).AOS.init());
